import plans from "./plans/PlansActions"
import { VGActions } from "react-visioglobe"

export default {
  plans,
  vg: VGActions
}



// WEBPACK FOOTER //
// ./src/store/actions.js